import config from "@/config/index";
// import auth0Js from 'auth0-js';
import auth0Variables from '../../utils/auth0-variables';
import axios from '../../utils/axios-util';
import VueJwtDecode from 'vue-jwt-decode'
import {
    AUTH0LOGINSUCCESS,
    AUTH0LOGOUTSUCCESS,
    CommitNothing,
    RESETTOKEN
} from "../mutation-types";
const state = config.auth0;
var variables = auth0Variables();
var token = '';
var permissionInfo = '';
// var auth0 = new auth0Js.WebAuth({
//     domain: variables.domain,
//     clientID: variables.clientId,
//     redirectUri: variables.callbackUrl,
//     audience: variables.audience,
//     responseType: 'token id_token',
//     scope: 'openid profile offline_access'
// });
const getters = {
    UserPermissions: state => state.settings.permissions,
}
const mutations = {
    [CommitNothing]: () => {},
    [AUTH0LOGINSUCCESS]: (state, payload) => {
        state.auth0.isLoggedIn = true;
        state.auth0.accessToken = payload.token;
        state.auth0.api_url = payload.api_url;
        state.auth0.portal_url = payload.portal_url;
        state.auth0.tenant_code = payload.tenant_code;
    },
    [AUTH0LOGOUTSUCCESS]: (state) => {
        state.auth0.isLoggedIn = false;
        state.auth0.accessToken = '';
    },
    [RESETTOKEN]: (state, payload) => {
        state.auth0.accessToken = payload;
    }
};
const actions = {
    auth0Login: (_, data) => {
        let payload = {
            password: data.password,
            username: data.email.toLowerCase()
        }
        return new Promise((resolve, reject) => {
            try {
                const regex = /doocti/g;
                const matches = window.location.hostname.match(regex);
                let apiurl = ''
                if (matches !== null && matches[0] === "doocti") {
                    apiurl = variables.common_api_url
                }
                else {
                    apiurl = variables.common_api_url
                    // apiurl='https://api-v2.'+window.location.hostname
                }
                payload.role = 1
                axios.post(`${apiurl}/v2/admin/login`, payload)
                    .then(response => {
                        resolve(response.data.access_token);
                    })
                    .catch(error => {
                        if (error.response.status === 500) {
                            reject(error);
                        } else {
                            reject(error);
                        }
                    })

            } catch (err) {
                reject(err)
            }
        })
    },
    GetSystemSettings: ({commit},) => {
        return new Promise((resolve, reject) => {
            try {
                axios.get(`/systemconfig`).then(response => {                    
                    if(response.data.system_config.dnd_check === true){
                        let config_value = JSON.parse(localStorage.getItem("projectConfig"))
                        config_value.projects[0].config[0].dnd_check = response.data.system_config.dnd_check
                        localStorage.setItem("projectConfig", JSON.stringify(config_value))
                    }
                    commit(CommitNothing, {});
                    delete  response.data.data[0].lead_id
                    resolve(response.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    },
    auth0Parse: ({ commit, dispatch }, data) => {
        return new Promise((resolve, reject) => {
            console.log("auth0Parse", data)
            var decoded_token = VueJwtDecode.decode(data);
            var tenant_code = decoded_token["http://api.doocti.com/claims/tenant_code"];
            localStorage.setItem("TenantCode", tenant_code);
            localStorage.setItem("editfields", false);
            // var api_url = decoded_token["http://api.doocti.com/claims/api_domain"];
            // var portal_url = decoded_token["http://api.doocti.com/claims/portal_domain"];
            var user_email = decoded_token["http://api.doocti.com/claims/email"];
            var config1 = {
                headers: {
                    Authorization: `Bearer ${data}`,
                },
            };
            const regex = /doocti/g;
            const matches = window.location.hostname.match(regex);
            let apiurl = ''
            if (matches !== null && matches[0] === "doocti") {
                apiurl = variables.common_api_url
            }
            else {
                apiurl = variables.common_api_url
                // apiurl='https://api-v2.'+window.location.hostname
            }
            axios
                .get(`${apiurl}/common/project/config?tenant_code=${tenant_code}&user_email=${user_email}`, config1)
                .then(response => {
                    var apiInfo = {
                        token: data,
                        portal_url: "https://" + response.data.projects[0].config[0].portal_domain,
                        api_url: "https://" + response.data.projects[0].config[0].api_domain,
                        tenant_code: tenant_code,
                        user_email: user_email,
                        sub_version: response.data.projects[0].config[0].sub_version ? response.data.projects[0].config[0].sub_version : ""
                    }
                    localStorage.apiInfo = JSON.stringify(apiInfo);
                    localStorage.projectConfig = JSON.stringify(response.data);
                    localStorage.projectId = response.data.projects[0].id;
                    axios.defaults.baseURL = apiInfo.portal_url;
                    axios.defaults.headers.Authorization = `Bearer ${apiInfo.token}`;
                    commit(AUTH0LOGINSUCCESS, apiInfo);
                    dispatch('getUserPermissions').then(() => {

                        resolve();
                        // localStorage.setItem('Team', JSON.stringify([]))
                        // localStorage.setItem('Team_group_user', JSON.stringify([]))
                        // localStorage.setItem('Team_admin_user', JSON.stringify([]))
                        // localStorage.setItem('Team_agent_user', JSON.stringify([]))
                        // dispatch("GetSystemSettings").then((res_systemconfig) => {
                        //     let config_value = JSON.parse(localStorage.getItem("projectConfig"))
                        //     config_value.masking_visible_char = res_systemconfig.data[0].masking_visible_char
                        //     config_value.meeting_interval = res_systemconfig.data[0].meeting_interval
                        //     localStorage.setItem("projectConfig", JSON.stringify(config_value))
                        //     resolve();
                        // }).catch((err) => {
                        //     console.log("GetSystemSettings Err:", err)
                        // })


                    });
                })
                .catch((err) => {
                    reject(err)
                });


        })
    },
    tokencheck: ({ commit }) => {
        token = localStorage.getItem('userToken');
        permissionInfo = JSON.parse(localStorage.getItem('permissionInfo'));
        // const username = JSON.parse(localStorage.getItem('projectConfig'));
        // console.log('username', username.projects[0].userInfo[0].user_name)
        if (state.auth0.accessToken == '') {
            commit(RESETTOKEN, token);
        }
        if (permissionInfo) {
            commit('ModifyUserPermissions', permissionInfo);
        }
    },
    domaininfo: (_, data) => {

        return new Promise((resolve, reject) => {
            try {
                let apiurl = variables.common_api_url
                // let apiurl =  'https://dialer-smibrahim.doocti.com/'
                axios.get(`${apiurl}/${data}`)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        if (error.response.status === 500) {
                            reject(error);
                        } else {
                            reject(error);
                        }
                    })

            } catch (err) {
                reject(err)
            }
        })
    },
    auth0Logout: ({ commit }) => {
        return new Promise((resolve, reject) => {
            localStorage.clear();
            try {

                commit(AUTH0LOGOUTSUCCESS);
                localStorage.removeItem("apiInfo");
                localStorage.removeItem("projectConfig");
                localStorage.removeItem("projectId");
                localStorage.removeItem("group_template");
                localStorage.removeItem("group_users");
                localStorage.removeItem("group_queue");
                localStorage.removeItem("group_disposition");
                resolve();
            } catch (error) {
                reject(error)
            }
        })
    }
};
export default {
    state,
    getters,
    mutations,
    actions
};